export enum EventRestrictionType {
  DEFAULT = 'DEFAULT',
  COVID = 'COVID',
  BAGS = 'BAGS',
  SOCIAL = 'SOCIAL',
  MERCHANDISE = 'MERCHANDISE',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/event-restriction-type.ts